import { useSelector } from "react-redux";
import { translations, normalizeLang } from "../../i18n";

import historyVideoPoster from "../../assets/img/parking_preview.jpg";

let __cachedVidKeyframesInjected = false;
if (typeof document !== "undefined" && !__cachedVidKeyframesInjected) {
  const styleEl = document.createElement("style");
  styleEl.textContent = `
  @keyframes pli-shimmer { 100% { transform: translateX(100%); } }
  @keyframes pli-fade { from { opacity:0; } to { opacity:1; } }
  `;
  document.head.appendChild(styleEl);
  __cachedVidKeyframesInjected = true;
}

const Parking = () => {
  const user = useSelector((state) => state.user.data);

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];
  const openYandexRoute = () => {
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);

    const lat = 55.777503817025554;
    const lon = 37.601577823334196;

    const webUrl = `https://yandex.ru/maps/?whatshere[point]=${lon},${lat}&whatshere[zoom]=19.99&ll=${lon},${lat}&z=19.99`;

    const appUrl = `yandexmaps://maps.yandex.ru/?ll=${lon},${lat}&z=19.99&pt=${lon},${lat}`;
    const intentUrl = `intent://maps.yandex.ru/?ll=${lon},${lat}&z=19.99&pt=${lon},${lat}#Intent;scheme=yandexmaps;package=ru.yandex.yandexmaps;end`;

    const tg = window.Telegram && window.Telegram.WebApp;
    if (tg && typeof tg.openLink === "function") {
      tg.openLink(webUrl, { try_instant_view: false });
      return;
    }

    const started = Date.now();
    const fallback = setTimeout(() => {
      if (Date.now() - started < 1800) {
        window.open(webUrl, "_blank", "noopener,noreferrer");
      }
    }, 1200);

    const clear = () => {
      clearTimeout(fallback);
      window.removeEventListener("blur", clear);
      document.removeEventListener("visibilitychange", onVis);
    };
    const onVis = () => {
      if (document.hidden) clear();
    };
    window.addEventListener("blur", clear);
    document.addEventListener("visibilitychange", onVis);

    if (isAndroid) {
      window.location.href = intentUrl;
    } else {
      window.location.href = appUrl;
    }
  };
  return (
    <div>
      <div style={{ fontSize: "12px", margin: "0 15px", display: "flex" }}>
        <svg
          style={{ marginRight: "5px" }}
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 0C3.35775 0 0 3.35775 0 7.5C0 11.6422 3.35775 15 7.5 15C11.6422 15 15 11.6422 15 7.5C15 3.35775 11.6422 0 7.5 0ZM7.5 1.5C10.8135 1.5 13.5 4.1865 13.5 7.5C13.5 10.8135 10.8135 13.5 7.5 13.5C4.1865 13.5 1.5 10.8135 1.5 7.5C1.5 4.1865 4.1865 1.5 7.5 1.5ZM10.266 3.79651L5.766 5.29651C5.54175 5.37151 5.3715 5.54174 5.2965 5.76599L3.7965 10.266C3.6015 10.8517 4.14825 11.3985 4.734 11.2035C5.29725 11.0152 8.6715 9.89099 9.234 9.70349C9.45825 9.62849 9.6285 9.45826 9.7035 9.23401L11.2035 4.73401C11.3985 4.14826 10.8518 3.60151 10.266 3.79651ZM9.3285 5.67151L8.41425 8.41425C7.82475 8.61075 6.75075 8.96849 5.6715 9.32849L6.58575 6.58575L9.3285 5.67151Z"
            fill="black"
            fillOpacity="0.85"
          />
        </svg>
        <p>{t.parkingTitle}</p>
      </div>
      <div className="res__contents">
        <div className="res__content">
          {/* <div className='res__img-wrapper'>
                <CachedVideo />
            </div> */}
          <h2 style={{ marginTop: "10px" }}>
            <b>{t.guestParkingHeadline}</b>
          </h2>
          <div className="res__text">
            <p>
              {t.howItWorksP1}
            </p>
            <p style={{ marginTop: "10px" }}>
              {t.howItWorksP2}
            </p>
            <p style={{ marginTop: "10px" }}>
              {t.barrierPhoneLabel}{" "}
              <a
                style={{
                  color: "#366091",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
                href="tel:+74950214425"
                target="_blank"
                rel="noreferrer"
              >
                +7 (495) 021-44-25
              </a>
            </p>
            <p style={{ marginTop: "10px" }}>
              {t.howItWorksP3}
            </p>
            <p>{t.howItWorksP4}</p>
            <p style={{ marginTop: "10px" }}>
              {t.parkingWalkDistance}
            </p>
            <p style={{ marginTop: "10px" }}>
              {t.parkingNotesTitle}
            </p>
            <p>{t.parkingNote1}</p>
            <p>{t.parkingNote2}</p>
            <p style={{ marginTop: "10px" }}>
              {t.parkingThanks}
            </p>
          </div>
          <div style={{ marginTop: "10px" }}>
            <button
              type="button"
              onClick={openYandexRoute}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                height: 36,
                padding: "0 12px",
                borderRadius: 999,
                backgroundColor: "#F2F2F2",
                color: "#111",
                fontSize: 14,
                letterSpacing: 0.2,
                lineHeight: "36px",
                cursor: "pointer",
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = "translateY(1px)";
                e.currentTarget.style.boxShadow = "0 0 0 rgba(0,0,0,0)";
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = "";
                e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.06)";
              }}
              aria-label={t.yandexAriaLabel}
              title={t.yandexTitle}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 12 6 12s6-6.75 6-12c0-3.314-2.686-6-6-6zm0 8.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
                  fill="#366091"
                />
              </svg>
              <span>{t.buildRouteButton}</span>
            </button>
          </div>
        </div>
        <p style={{marginTop: "10px", fontWeight: "bold"}}>{t.parkingVideo}</p>
        <video
                      controls
                      playsInline
                      preload="metadata"
                      poster={historyVideoPoster}
                      width="100%"
                      height="100%"
                      style={{
                        borderRadius: "8px",
                        objectFit: "cover",
                        background: "black",
                        marginTop: "10px"
                      }}
                    >
                      <source src="https://storage.yandexcloud.net/musie/Residence_bot_content/Video/Parking.mp4" type="video/mp4" />
                      {t.videoUnsupported}
                    </video>
      </div>
    </div>
  );
};

export default Parking;
